<template>
  <div
    id="canvasPlayer"
    class="canvas"
    :class="isMobile ? 'canvas-player-mb' : 'canvas-player-pc'">
    <Loading  v-if="isLoading"/>
  </div>
</template>
<script>

import Loading from './loading.vue';

export default {
    name: 'CanvasPlayer',
    components: {
        Loading
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        isTurn: {
            type: Boolean,
            default: false
        },
        prizeKey: {
            type: String
        }
    },
    data() {
        return {
            isLoading: false,
            isRunning: false,
            isStarting: false
        };
    },
    watch: {
        isTurn() {
            this.startTrailer();
        }
    },
    mounted() {
        setTimeout(() => {
            this.drawPixi();
        }, 1000);
    },
    methods: {
        startTrailer() {
            if (this.screen.state.hasAnimation(!this.isTurn ? 'idle' : this.prizeKey)) {
                this.screen.state.setAnimation(0, !this.isTurn ? 'idle' : this.prizeKey, true);
            }
        },
        async startPrizeAnimation(prizeIds) {
            this.isRunning = true;
            // eslint-disable-next-line no-restricted-syntax
            for (const prizeId of prizeIds) {
                if (this.screen.state.hasAnimation(`prize${prizeId}`)) {
                    this.screen.state.setAnimation(0, `prize${prizeId}`, false);
                    // eslint-disable-next-line no-await-in-loop
                    await this.waitAnimation();
                }
            }
            this.isRunning = false;
        },
        async drawPixi() {
            this.isLoading = true;
            // eslint-disable-next-line import/no-extraneous-dependencies
            const SPINE = await import('pixi-spine');
            const app = new global.PIXI.Application({
                width: window.innerWidth,
                height: this.isMobile ? 830 : window.innerHeight,
                antialias: true,
                transparent: true,
                powerPreference: 'high-performance',
                resolution: window.devicePixelRatio || 1,
                autoDensity: true
            });
            app.loader
                .add('anim', '/assets/animation/worldcup/wheel/sprites_vongquaywc.json')
                .load((loader, resources) => {
                    const screen = new SPINE.Spine(resources.anim.spineData);
                    screen.x = app.screen.width / 2;
                    screen.y = this.isMobile ? 190 : 260;
                    screen.scale.set(this.calculateRatio(app));
                    app.stage.addChild(screen);
                    this.screen = screen;
                    this.startTrailer();
                    app.start();
                    this.isLoading = false;
                });
            this.$el.appendChild(app.view);
            app.renderer.autoResize = true;
            app.renderer.plugins.interaction.autoPreventDefault = false;
            app.renderer.view.style['touch-action'] = 'auto';
            const width = app.view.parentNode.clientWidth;
            app.renderer.resize(width, this.isMobile ? 360 : 480);
        },
        calculateRatio(app) {
            // eslint-disable-next-line no-nested-ternary
            const wData = app.view.parentNode.clientWidth;
            let scaleData = 0;
            if (this.isMobile) {
                if (wData > 500) {
                    scaleData = 0.63;
                } else {
                    scaleData = app.screen.width / 670;
                }
            } else {
                scaleData = 0.85;
            }
            return scaleData;
        }
    }
};
</script>

<style scoped lang="scss">
.canvas-player {
  &-pc {
    height: 480px;
  }
  &-mb {
    padding-top: 15px;
    text-align: center;
    width: 100%;
    @media screen and (max-width: 992px) {
      padding-top: 0;
      margin-top: -60px;
    }
    @media screen and (max-width: 576px) {
      padding-top: 0;
      margin-top: -72px;
    }
  }

  &-kickoff {
    ::v-deep canvas {
      position: relative !important;
    }
  }
}

</style>
